import React, { Children } from 'react'
import clsx from 'clsx'
import { makeStyles } from '@material-ui/core/styles'

// Local replacement for react-storefront/Fill. Maintains a fixed aspect
// ratio (via a padding-top spacer) and absolutely positions the child to
// fill it. When `height` is omitted it just renders the single child.
const useStyles = makeStyles({
  root: {
    position: 'relative',
    width: '100%',
  },
  child: {
    position: 'absolute',
    top: 0,
    left: 0,
    width: '100%',
    height: '100%',
    '& > *': {
      width: '100%',
      height: '100%',
    },
  },
})

export default function Fill({ height, children, className, ...props }) {
  children = Children.only(children)

  if (height == null) {
    return children
  }

  const classes = useStyles()
  return (
    <div className={clsx(classes.root, className)} {...props}>
      <div style={{ paddingTop: height }} />
      <div className={classes.child}>{children}</div>
    </div>
  )
}
